import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import FaqLayout from 'cms/faqs/FaqLayout';
import {Card, CardBody} from 'components/card';
import RetrieveType from 'cms/faqs/Article/RetrieveType';
import Loader from 'helpers/Loader';
import Alert from 'helpers/Alert';
import spinnerCometSVG from 'assets/images/svg/spinner/comet.svg';

const Page = ({store}) => {
  const {loading, errorOccured, breadcrump, title, content,
    modified, categories, remoteContent: {retrieveType, data: remoteData}, translations} = store;
  const {lastUpdated, anErrorOccured} = translations;

  return (
    <FaqLayout breadcrump={breadcrump} categories={categories} translations={translations}>
      <Card className="border-0 faq-card">
        <CardBody className="p-4">
          {
            loading ?
              <Loader img={spinnerCometSVG} className='m-3' /> :
              errorOccured ?
                <Alert type="warning" message={anErrorOccured} /> :
                <>
                  <div className="d-flex justify-content-between text-muted">
                    <span className="text-small">{lastUpdated.replace('{date}', modified)}</span>
                    <i
                      className="icon icon-print text-muted"
                      onClick={() => window.print()}
                    />
                  </div>
                  <h1 className="display-4 font-light my-2" dangerouslySetInnerHTML={{__html: title}}></h1>
                  <p dangerouslySetInnerHTML={{__html: content}}></p>
                  {
                    remoteData &&
                      <RetrieveType
                        retrieveType={retrieveType}
                        data={remoteData}
                        translations={translations}
                      />
                  }
                </>
          }
        </CardBody>
      </Card>
    </FaqLayout>
  );
};

Page.propTypes = {
  store: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    errorOccured: PropTypes.bool.isRequired,
    breadcrump: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    modified: PropTypes.string.isRequired,
    categories: PropTypes.array.isRequired,
    remoteContent: PropTypes.object.isRequired,
    translations: PropTypes.shape({
      anErrorOccured: PropTypes.string.isRequired,
      lastUpdated: PropTypes.string.isRequired,
      sidebarLabel: PropTypes.string.isRequired,
      placeholderSearch: PropTypes.string.isRequired,
      port: PropTypes.string.isRequired,
      agency: PropTypes.string.isRequired,
      phone: PropTypes.string.isRequired,
      address: PropTypes.string.isRequired,
      zipCode: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};

export default observer(Page);
